module.exports = __webpack_public_path__ + "media/voice.95f6adc4.mp3";